export default __webpack_public_path__ + "static/media/SEGUISB.6e8b789f.TTF";